/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_RefreshedInputs */

const vi_einvoice_refreshed = /** @type {(inputs: Einvoice_RefreshedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã làm mới trạng thái hóa đơn`)
};

/**

* @param {Einvoice_RefreshedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_refreshed = /** @type {((inputs?: Einvoice_RefreshedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_RefreshedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_refreshed(inputs)
});